<template>
<m-pageframe
    :title="title"
>
<v-container
    v-if="info != null"
>
    <h2>{{phone_number_heading}}</h2>

    <v-data-table
        :headers="endpoint_headers"
        :items="info.endpoints"
        :items-per-page="100"
        :hide-default-footer="true"
        class="elevation-1"
        style="margin-top: 15px;"

        :footer-props="{
            disableItemsPerPage: true,
            disablePagination: true,
            }"
    >
        <template v-slot:item.endpoint="{ item }">
            {{prettyPrintEndpoint(item.endpoint)}}
        </template>

       <template v-slot:item.following_reason="{ item }">
           {{prettyReason(item)}}
        </template>

        <template v-slot:item.action="{ item }">
           <a 
                v-on:click="onClickStopFollowingNumber(item)" 
                v-if="canStopFollowingNumber(item)"
            >
                Stop Following...
            </a>
        </template>

    </v-data-table>

     <m-icon-bar
        v-on:add="onClickAddFollowPhoneNumber"
    />

    <m-dialog-employee-following-add-endpoint
        ref="add-endpoint-dialog"
        v-on:ok="onFollowEndpoint"
    />

    <h2>{{conversations_heading}}</h2>

    <v-data-table
        :headers="conversation_headers"
        :items="info.conversations"
        :items-per-page="100"
        :hide-default-footer="true"
        class="elevation-1"
        style="margin-top: 15px;"

        :footer-props="{
            disableItemsPerPage: true,
            disablePagination: true,
            }"
    >

       <template v-slot:item.following_reason="{ item }">
           {{prettyConvReason(item)}}
        </template>

        <template v-slot:item.action="{ item }">
           <a 
                v-on:click="onClickStopFollowingConversation(item)"
            >
                Stop Following...
            </a>
        </template>

    </v-data-table>

     <m-icon-bar
        v-on:add="onClickAddFollowConversation"
    />

    <m-dialog-add-follow-conversation
        ref="add-follow-conversation-dialog"
        v-on:ok="onFollowConversation"
    />


</v-container>
</m-pageframe>
</template>

<script>
const E164 = require('@/js/E164.js');
export default {
    data() {
        return {
            info: null,

            endpoint_headers: [
                { 'text' : 'Label', 'value' : 'endpoint_label' },
                { 'text' : 'Phone Number', 'value' : 'endpoint' },
                { 'text' : 'Following Because', 'value' : 'following_reason' },
                { 'text' : 'Action', 'value' : 'action' },
            ],

            conversation_headers: [
                { 'text' : 'Label', 'value' : 'conversation_label' },
                { 'text' : 'Reason', 'value' : 'reason' },
                { 'text' : 'Action', 'value' : 'action' },
            ],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.showSpinner();
            
            this.$rc.getEmployeeFollowingInfo(
                this.$route.params.employee_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.info = data;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get following information');
                },
            );
        },

        prettyPrintEndpoint(endpoint) {
            if ( endpoint == null ) return null;
            return E164.prettyPrintUsPhoneNumber(endpoint);
        },

        prettyReason(item)
        {
            let reason = item.following_reason;

            if ( reason == 'assigned-to-employee' )
            {
                return this.is_you ? "This number has been assigned to you" : "This phone number has been assigned to "+this.info.employee_label;
            }

            if ( reason == 'assigned-to-employee-group' )
            {
                return this.is_you ?
                    "You are a member of the '"+item.group_label+"' group" :
                    this.info.employee_label+" is a member of the '"+item.group_label+"' group";
            }

            if ( reason == 'manually-followed' )
            {
                return this.is_you ?
                    "You were manually set to follow this phone number" :
                    this.info.employee_label+" was manually set to follow this phone number";
            } 

            return reason;
        },

        prettyConvReason()
        {
            return this.is_you ?
                    "You were manually set to follow this conversation" :
                    this.info.employee_label+" was manually set to follow this conversation";
        },

        onClickStopFollowingNumber(item)
        {
            this.$rc.confirm(
                    'Confirm',
                    'Stop following '+item.endpoint_label+' '+E164.prettyPrintUsPhoneNumber(item.endpoint)+"?",
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Confirm', 'value': 'confirm'},
                    ],

                    (response) => {
                        if (response == 'confirm') {
                            this.onDoStopFollowingNumber(item);
                        } else {
                            return;
                        }
                    }
                );
        },

        onDoStopFollowingNumber(item)
        {
            let params = {
                'employee_id' : this.$route.params.employee_id,
                'endpoint' : item.endpoint,
                'action' : 'stop-following'
            };

            this.$rc.showSpinner();
            
            this.$rc.followEndpoint(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                    this.$rc.snackbar('You have stopped following a phone number', 2000);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickStopFollowingConversation(item)
        {
            this.$rc.confirm(
                    'Confirm',
                    'Stop following '+item.conversation_label+"?",
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Confirm', 'value': 'confirm'},
                    ],

                    (response) => {
                        if (response == 'confirm') {
                            this.onDoStopFollowingConversation(item);
                        } else {
                            return;
                        }
                    }
                );
        },

        onDoStopFollowingConversation(item)
        {
            let params = {
                'employee_id' : this.$route.params.employee_id,
                'conversation_id' : item.conversation_id,
                'action' : 'stop-following'
            };

            this.$rc.followConversation(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                    this.$rc.snackbar('You have stopped following a conversation', 2000);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickAddFollowPhoneNumber()
        {
            this.$refs['add-endpoint-dialog'].showDialog(this.info.not_following_endpoints);
        },

        onClickAddFollowConversation()
        {
            this.$refs['add-follow-conversation-dialog'].showDialog(this.info.employee_account.organization_id);
        },

        onFollowConversation(conversation_id)
        {
            let params = {
                'employee_id' : this.$route.params.employee_id,
                'conversation_id' : conversation_id,
                'action' : 'start-following'
            };

            this.$rc.followConversation(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();

                    if ( data.already_following_conversation )
                        this.$rc.snackbar(this.is_you ? 'You were already following this conversation -- no change made' : this.info.employee_label+' was already following this conversation -- no change made', 3000);
                    else    
                        this.$rc.snackbar(this.is_you ? 'You are now following this conversation' : this.info.employee_label+' is now following this conversation', 3000);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onFollowEndpoint(endpoint)
        {
            let params = {
                'employee_id' : this.$route.params.employee_id,
                'endpoint' : endpoint,
                'action' : 'start-following'
            };

            this.$rc.showSpinner();
            
            this.$rc.followEndpoint(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        canStopFollowingNumber(item)
        {
            return item.following_reason == 'manually-followed';
        }
    },

    computed: {
        title() {
            let info = this.info;
            if ( info == null ) 
                return 'Following Phone Numbers and Conversations';

            return 'Following Phone Numbers and Conversations: '+info.employee_label;
        },

        is_you()
        {
            return this.info == null || this.info.employee_account.employee_id == this.$rc.$state.employee_id;
        },

        phone_number_heading()
        {
            if ( this.is_you )
                return "Phone Numbers You Are Following";
            
            return "Phone Numbers "+this.info.employee_label+" is following";
        },

        conversations_heading()
        {
            if ( this.is_you )
                return "Conversations You Are Following";
            
            return "Conversations "+this.info.employee_label+" is following";
        },
    },
}
</script>

<style lang="scss" scoped>
</style>